<div class="row">
	<div class="col-6">
		<mat-form-field class="lessPadding" matTooltip="{{ project.projectName }}">
			<mat-label>{{ _lang("attributes.name") }}</mat-label>
			<input
				#projectName="ngModel"
				(ngModelChange)="inputModelChanged(projectName.value)"
				[(ngModel)]="project.projectName"
				[disabled]="defaultDisabledCondition()"
				id="project_data_input-projectName"
				matInput
				required
				maxlength="255"
			/>
			@if ((isAddMode && projectName.control.untouched) || (isEditMode && !projectName.value)) {
				<mat-hint [ngStyle]="{color: 'red'}">
					{{ _lang("attributes.project-name-required") }}
				</mat-hint>
			}
		</mat-form-field>
	</div>
	<div class="col-6">
		<mat-form-field class="lessPadding">
			<mat-label>{{ _lang("attributes.client") }}</mat-label>
			<input
				#client
				(ngModelChange)="inputModelChanged(project.client)"
				[(ngModel)]="project.client"
				[disabled]="defaultDisabledCondition()"
				[matAutocomplete]="clientAuto.matAutocomplete"
				id="project_data_input-client"
				matInput
				maxlength="255"
			/>
			<app-client-autocomplete
				#clientAuto
				[inputElement]="client"
				[filterBusinessUnit]="project.businessUnit"
			></app-client-autocomplete>
		</mat-form-field>
	</div>
</div>

<div class="row">
	<div class="col-6">
		<mat-form-field class="lessPadding">
			<mat-label>{{ _lang("attributes.project_lead") }}</mat-label>
			<input
				#projectLeader="ngModel"
				#projectLeaderInput
				matInput
				id="project_data_input-projectLeader"
				required
				[(ngModel)]="project.projectLeader"
				(ngModelChange)="projectLeaderChanged(project.projectLeader)"
				[disabled]="defaultDisabledCondition()"
				[matAutocomplete]="autoProjectLeader.matAutocomplete"
				maxlength="255"
			/>
			<app-employee-autocomplete
				#autoProjectLeader
				[inputElement]="projectLeaderInput"
				(elementSelected)="updateProjectLeader($event)"
			>
			</app-employee-autocomplete>
			@if (
				(isAddMode && projectLeader.control.untouched) ||
				(isEditMode && (!projectLeader.value || !projectLeaderSelected))
			) {
				<mat-hint [ngStyle]="{color: 'red'}">
					{{ _lang("attributes.project-leader-required") }}
				</mat-hint>
			}
		</mat-form-field>
	</div>
	<div class="col-6">
		@if (!isCurrentClientZT()) {
			<mat-form-field class="lessPadding">
				<mat-label>{{ _lang("attributes.division_manager") }}</mat-label>
				<input
					matInput
					maxlength="255"
					id="project_data_input-divisionManager"
					#divisionManager="ngModel"
					#divisionManagerInput
					required
					[(ngModel)]="project.divisionManager"
					(ngModelChange)="divisionManagerChanged(project.divisionManager)"
					[disabled]="defaultDisabledCondition()"
					[matAutocomplete]="autoDivisionManager.matAutocomplete"
				/>
				<app-employee-autocomplete
					#autoDivisionManager
					(elementSelected)="updateDivisionManager($event)"
					[inputElement]="divisionManagerInput"
					[onlyDivLeaderOrManager]="!isCurrentClientZT()"
				>
				</app-employee-autocomplete>
				@if (
					(isAddMode && divisionManager.control.untouched) ||
					(isEditMode && (!divisionManager.value || !divisionManagerSelected))
				) {
					<mat-hint [ngStyle]="{color: 'red'}">
						{{ _lang("attributes.division-manager-required") }}
					</mat-hint>
				}
			</mat-form-field>
		}
	</div>
</div>

<div class="row">
	<div class="col-12">
		<mat-form-field class="lessPadding">
			<mat-label>{{ _lang("attributes.msg_unit") }}</mat-label>
			<mat-select
				[(ngModel)]="project.msgUnit"
				id="project_data_input-msg_unit"
				[disabled]="defaultDisabledCondition()"
				(ngModelChange)="inputModelChanged(project.msgUnit)"
				(selectionChange)="updateBusinessUnitsBasedOnMsgUnit(project.msgUnit)"
				[attr.e2evalue]="project.msgUnit"
			>
				@for (unit of msgUnit; track unit) {
					<mat-option [value]="unit.value" id="select-option-{{ unit.value }}">{{ unit.viewValue }} </mat-option>
				}
			</mat-select>
		</mat-form-field>
	</div>
</div>

<div class="row">
	<div class="col-6">
		<mat-form-field class="lessPadding">
			<mat-label>{{ _lang("attributes.business_unit") }}</mat-label>
			<mat-select
				[(ngModel)]="project.businessUnit"
				id="project_data_input-business_unit"
				[disabled]="defaultDisabledCondition()"
				(ngModelChange)="inputModelChanged(project.businessUnit)"
				(selectionChange)="updateDivisionsAndBusinessTopics()"
				[attr.e2evalue]="project.businessUnit"
			>
				@for (unit of businessUnit; track unit) {
					<mat-option [value]="unit.value" id="select-option-{{ unit.value }}">{{ unit.viewValue }} </mat-option>
				}
			</mat-select>
		</mat-form-field>
	</div>
	<div class="col-6">
		@if (!isCurrentClientMSAOrZMOrGBPOrCONPLANOrGBG() && !isCurrentClientZT()) {
			<mat-form-field class="lessPadding">
				<mat-label>{{ _lang("attributes.division") }}</mat-label>
				<input
					matInput
					maxlength="255"
					id="project_data_input-division-ft"
					[disabled]="defaultDisabledCondition()"
					[(ngModel)]="project.division"
					(ngModelChange)="inputModelChanged(project.division)"
				/>
			</mat-form-field>
		}
		@if (isCurrentClientMSAOrZMOrGBPOrCONPLANOrGBG()) {
			<mat-form-field class="lessPadding">
				<mat-label>{{ _lang("attributes.division") }}</mat-label>
				<mat-select
					#division="ngModel"
					id="project_data_input-division"
					[disabled]="defaultDisabledCondition()"
					[required]="isCurrentClientGBP()"
					[(ngModel)]="project.division"
					(ngModelChange)="inputModelChanged(project.division)"
					[attr.e2evalue]="project.division"
					[ngStyle]="{color: isEditMode ? 'black' : 'gray'}"
				>
					@for (option of divisions; track option) {
						<mat-option id="select-option-{{ option.value }}" [value]="option.value"
							>{{ option.viewValue }}
						</mat-option>
					}
				</mat-select>
				@if (division.hasError("required")) {
					<mat-error>{{ _lang("attributes.division-required") }}</mat-error>
				}
				@if (isCurrentClientGBP() && ((isAddMode && division.control.untouched) || isEditMode) && !division.value) {
					<mat-hint [ngStyle]="{color: 'red'}">
						{{ _lang("attributes.division-required") }}
					</mat-hint>
				}
			</mat-form-field>
		}
	</div>

	@if (!project.projectScopePd) {
		<div class="row m-0 p-0">
			<div class="col-6">
				<mat-form-field class="lessPadding">
					<mat-label>{{ _lang("attributes.project_scope_pd") }}</mat-label>
					<input
						#projectScopeEmpty
						#client
						id="project_data_input-projectScopePd"
						matInput
						maxlength="255"
						[disabled]="defaultDisabledCondition()"
						[(ngModel)]="project.projectScopePd"
						(ngModelChange)="chartInputModelChanged(project.projectScopePd)"
						type="number"
					/>
				</mat-form-field>
			</div>
			<div class="col-6">
				<mat-form-field class="lessPadding" [matTooltip]="_lang('attributes.project_volume')">
					<mat-label>{{ _lang("attributes.project_volume") }}</mat-label>
					<input
						matInput
						maxlength="255"
						#client
						[disabled]="defaultDisabledCondition()"
						[(ngModel)]="project.projectVolume"
						(ngModelChange)="inputModelChanged(project.projectVolume)"
						type="number"
					/>
				</mat-form-field>
			</div>
		</div>
	}
	@if (project.projectScopePd) {
		<div class="row m-0 p-0">
			<div class="col-6">
				<div class="col-12">
					<mat-form-field class="lessPadding">
						<mat-label>{{ _lang("attributes.project_scope_pd") }}</mat-label>
						<input
							#projectScopeFilled
							#client
							id="project_data_input-projectScopePd"
							matInput
							maxlength="255"
							[disabled]="defaultDisabledCondition()"
							[(ngModel)]="project.projectScopePd"
							(ngModelChange)="chartInputModelChanged(project.projectScopePd)"
							type="number"
						/>
					</mat-form-field>
				</div>
				<div class="col-12">
					<mat-form-field class="lessPadding" [matTooltip]="_lang('attributes.project_volume')">
						<mat-label>{{ _lang("attributes.project_volume") }}</mat-label>
						<input
							matInput
							maxlength="255"
							#client
							[disabled]="defaultDisabledCondition()"
							[(ngModel)]="project.projectVolume"
							(ngModelChange)="inputModelChanged(project.projectVolume)"
							type="number"
						/>
					</mat-form-field>
				</div>
			</div>
			<div class="col-6 row-2 canvas-container" [matTooltip]="generateChartTooltip()">
				<canvas id="projectScopePieChart"></canvas>
			</div>
		</div>
	}
</div>

<div class="row">
	<div class="col-6">
		<mat-form-field class="lessPadding">
			<mat-label>{{ _lang("attributes.market_unit") }}</mat-label>
			<mat-select
				[(ngModel)]="project.marketUnit"
				id="project_data_input-market_unit"
				[disabled]="defaultDisabledCondition()"
				(ngModelChange)="inputModelChanged(project.marketUnit)"
				[attr.e2evalue]="project.marketUnit"
			>
				@for (unit of marketUnit; track unit) {
					<mat-option [value]="unit.value" id="select-option-{{ unit.value }}">
						{{ unit.viewValue }}
					</mat-option>
				}
			</mat-select>
		</mat-form-field>
	</div>
	<div class="col-6">
		<mat-form-field class="lessPadding">
			<mat-label>{{ _lang("attributes.market_unit_contact") }}</mat-label>
			<input
				matInput
				maxlength="255"
				id="project_data_input-marketUnitContact"
				[disabled]="defaultDisabledCondition()"
				(ngModelChange)="inputModelChanged(project.marketUnitContact)"
				[(ngModel)]="project.marketUnitContact"
			/>
		</mat-form-field>
	</div>
</div>

@if (!projectEditable) {
	<div class="row">
		<div class="col-6 pe-2">
			<mat-form-field class="pe-2">
				<mat-label>{{ _lang("attributes.start") }}</mat-label>
				<input
					[matDatepicker]="startDatePicker"
					id="project_data_input-startDate"
					matInput
					required
					[(ngModel)]="project.startDate"
					[disabled]="defaultDisabledCondition()"
					(ngModelChange)="inputModelChanged(project.startDate)"
				/>
				<mat-datepicker-toggle matSuffix [for]="startDatePicker" [disabled]="!isEditMode"></mat-datepicker-toggle>
				<mat-datepicker #startDatePicker></mat-datepicker>
			</mat-form-field>
		</div>
		<div class="col-6 pe-3">
			<mat-form-field class="pe-3 lessPadding">
				<mat-label>{{ _lang("attributes.end") }}</mat-label>
				<input
					[matDatepicker]="endDatePicker"
					id="project_data_input-endDate"
					matInput
					required
					[(ngModel)]="project.endDate"
					(ngModelChange)="inputModelChanged(project.endDate)"
					[disabled]="!isEditMode || !projectEditable"
				/>
				<mat-datepicker-toggle matSuffix [for]="endDatePicker" [disabled]="!isEditMode"></mat-datepicker-toggle>
				<mat-datepicker #endDatePicker></mat-datepicker>
			</mat-form-field>
		</div>
	</div>
}

<div class="row">
	<div class="col-6">
		<mat-form-field class="lessPadding">
			<mat-label>{{ _lang("attributes.technology_stack") }}</mat-label>
			<input
				matInput
				maxlength="255"
				id="project_data_input-technologyStack"
				[disabled]="defaultDisabledCondition()"
				[(ngModel)]="project.technologyStack"
				(ngModelChange)="inputModelChanged(project.technologyStack)"
			/>
		</mat-form-field>
	</div>
	<div class="col-6">
		<mat-form-field class="lessPadding" matTooltip="{{ project.psp }}">
			<mat-label>{{ isShowWorkPackageEnabled ? _lang("attributes.psp_s4") : _lang("attributes.psp") }}</mat-label>
			<input
				id="project_data_input-psp"
				matInput
				placeholder="{{ isShowWorkPackageEnabled ? _lang('attributes.psp_s4') : _lang('attributes.psp') }}"
				[disabled]="defaultDisabledCondition()"
				[(ngModel)]="project.psp"
				(ngModelChange)="inputModelChanged(project.psp)"
			/>
		</mat-form-field>
	</div>
</div>

<div class="row">
	<div class="col-6">
		<mat-form-field class="lessPadding">
			<mat-label>{{ _lang("attributes.status") }}</mat-label>
			<mat-select
				#status="ngModel"
				(ngModelChange)="inputModelChanged(project.status); projectStatusChanged(project.status)"
				[(ngModel)]="project.status"
				[disabled]="defaultDisabledCondition()"
				[required]="isAddMode"
				[attr.e2evalue]="project.status"
				id="project_data_input-status"
			>
				@for (status of projectStatus; track status) {
					<mat-option [value]="status" id="select-option-{{ status }}">
						{{ "mep.enum.project-status." + status | translate }}
					</mat-option>
				}
			</mat-select>
			@if (isAddMode && status.control.untouched) {
				<mat-hint [ngStyle]="{color: 'red'}">{{ _lang("attributes.project-status-required") }} </mat-hint>
			}
		</mat-form-field>
	</div>
	<div class="col-6">
		<mat-form-field class="lessPadding">
			<mat-label>{{ _lang("attributes.pl_cluster") }}</mat-label>
			<input
				matInput
				maxlength="255"
				id="project_data_input-plCluster"
				[disabled]="defaultDisabledCondition()"
				[(ngModel)]="project.plCluster"
				(ngModelChange)="inputModelChanged(project.plCluster)"
			/>
		</mat-form-field>
	</div>
</div>

@if (isAggregationAvailable && aggregatedProjectsDataSource?.data?.length > 0) {
	<div class="d-flex align-items-center justify-content-between mb-2 mt-2">
		<h3 class="mb-0">
			{{ _lang("attributes.aggregated_projects") }}
		</h3>
		<app-news-notification [messageKey]="'aggregate-projects.project-data'" insertDate="22.07.2025">
			<button
				class="mep-btn-small"
				id="add_aggregated_project"
				matTooltip="{{ _lang('add-aggregated-project') }}"
				(click)="openAddAggregatedProjectDialog()"
			>
				<mat-icon>add</mat-icon>
			</button>
		</app-news-notification>
	</div>
}

@if (aggregatedProjectsDataSource?.data?.length === 0 && isAggregationAvailable) {
	<app-news-notification [messageKey]="'aggregate-projects.project-data'" insertDate="22.07.2025">
		@if (aggregatedProjectsDataSource?.data?.length === 0 && isAggregationAvailable) {
			<button
				class="mep-btn-small w-100 mt-3 mb-3"
				id="add_first_aggregated_project"
				matTooltip="{{ _lang('add-aggregated-project') }}"
				(click)="openAddAggregatedProjectDialog()"
			>
				{{ _lang("add-aggregated-project") }}
			</button>
		}
	</app-news-notification>
}

@if (aggregatedProjectsDataSource?.data?.length > 0) {
	<div class="row table-container-normal">
		<div class="col-12">
			<table
				id="aggregatedTable"
				mat-table
				[dataSource]="aggregatedProjectsDataSource"
				multiTemplateDataRows
				matSort
				matSortActive="projectName"
				matSortDirection="asc"
				matSortDisableClear
			>
				<!-- //NOSONAR -->
				<ng-container matColumnDef="delete">
					<th mat-header-cell *matHeaderCellDef></th>
					<td *matCellDef="let row" mat-cell>
						<button
							(click)="deleteAggregatedProjectClicked(row)"
							id="delete_aggregated_project"
							color="primary"
							matTooltip="{{ _lang('delete_aggregated_project') }}"
							mat-icon-button
						>
							<mat-icon>delete</mat-icon>
						</button>
					</td>
				</ng-container>
				<ng-container matColumnDef="projectName">
					<th mat-header-cell *matHeaderCellDef mat-sort-header>{{ _lang("attributes.name") }}</th>
					<td *matCellDef="let row" mat-cell>
						<a
							routerLink="/project-edit/{{ row.sharePointId }}"
							class="project-link"
							(click)="_dataService.clearProjectCache()"
						>
							{{ row.projectName }}
						</a>
					</td>
				</ng-container>
				<ng-container matColumnDef="projectLeader">
					<th mat-header-cell *matHeaderCellDef mat-sort-header>{{ _lang("attributes.project_lead") }}</th>
					<td mat-cell *matCellDef="let row">
						@if (row.projectLeader) {
							<span>
								{{
									row.projectLeader?.firstName
										? row.projectLeader.firstName + " " + row.projectLeader.lastName
										: row.projectLeader
								}}
							</span>
						}
					</td>
				</ng-container>
				<ng-container matColumnDef="psp">
					<th mat-header-cell *matHeaderCellDef mat-sort-header>{{ _lang("attributes.psp") }}</th>
					<td mat-cell *matCellDef="let row">{{ row.psp | appPspListTransform }}</td>
				</ng-container>
				<ng-container matColumnDef="startDate">
					<th mat-header-cell *matHeaderCellDef mat-sort-header>{{ _lang("attributes.start") }}</th>
					<td *matCellDef="let row" mat-cell>{{ row.startDate | date: "dd.MM.yyyy" }}</td>
				</ng-container>
				<ng-container matColumnDef="endDate">
					<th mat-header-cell *matHeaderCellDef mat-sort-header>{{ _lang("attributes.end") }}</th>
					<td *matCellDef="let row" mat-cell>{{ row.endDate | date: "dd.MM.yyyy" }}</td>
				</ng-container>
				<tr mat-header-row *matHeaderRowDef="aggregatedProjectsDisplayedColumns; sticky: true"></tr>
				<tr mat-row *matRowDef="let row; columns: aggregatedProjectsDisplayedColumns; let i = index"></tr>
			</table>
		</div>
	</div>
}

<div class="row">
	<div class="col-12">
		<mat-form-field class="mat-form-field-w-auto lessPadding">
			<mat-label> {{ _lang("attributes.description") }}</mat-label>
			<textarea
				matInput
				id="project_data_input-description"
				[disabled]="defaultDisabledCondition()"
				[(ngModel)]="project.description"
				(ngModelChange)="inputModelChanged(project.description)"
			></textarea>
		</mat-form-field>
	</div>
</div>

<div class="row">
	@if (!projectEditable) {
		<div class="col-6">
			<mat-form-field class="lessPadding">
				<mat-label>{{ _lang("attributes.probabilitySP") }}</mat-label>
				<input
					matInput
					id="project_data_input-probabilitySP"
					[disabled]="defaultDisabledCondition()"
					[(ngModel)]="project.probabilitySP"
					(ngModelChange)="inputModelChanged(project.probabilitySP)"
					type="number"
					min="0"
					max="100"
				/>
			</mat-form-field>
		</div>
	}
	@if (isCurrentClientGBP()) {
		<div class="col-6">
			<mat-form-field class="lessPadding">
				<mat-label>{{ _lang("attributes.project-id") }}</mat-label>
				<input
					matInput
					maxlength="255"
					id="project_data_input-sharePointId"
					[disabled]="true"
					[(ngModel)]="project.sharePointId"
					(ngModelChange)="inputModelChanged(project.sharePointId)"
					type="number"
				/>
			</mat-form-field>
		</div>
	}
	<div class="col-6">
		<mat-form-field class="lessPadding">
			<mat-label>{{ _lang("attributes.strategic_objective") }}</mat-label>
			<mat-select
				[(ngModel)]="project.strategicObjective"
				id="project_data_input-strategic_objective"
				(ngModelChange)="inputModelChanged(project.strategicObjective)"
				[attr.e2evalue]="project.strategicObjective"
				[disabled]="defaultDisabledCondition()"
			>
				@for (object of strategicObjective; track object) {
					<mat-option [value]="object.value" id="select-option-{{ object.value }}">{{ object.viewValue }} </mat-option>
				}
			</mat-select>
		</mat-form-field>
	</div>
</div>
<div class="row">
	<div class="col-6">
		<mat-form-field class="lessPadding">
			<mat-label>{{ _lang("attributes.branch") }}</mat-label>
			<mat-select
				[(ngModel)]="project.branch"
				id="project_data_input-branch"
				(ngModelChange)="inputModelChanged(project.branch)"
				[attr.e2evalue]="project.branch"
				[disabled]="defaultDisabledCondition()"
			>
				@for (object of branches; track object) {
					<mat-option [value]="object.value" id="select-option-{{ object.value }}">{{ object.viewValue }} </mat-option>
				}
			</mat-select>
		</mat-form-field>
	</div>
	<div class="col-6">
		<mat-form-field class="lessPadding">
			<mat-label>{{ _lang("attributes.mec_category") }}</mat-label>
			<mat-select
				#projectCategory="ngModel"
				id="project_data_input-mec_category"
				[required]="isAddMode"
				[(ngModel)]="project.projectCategory"
				(ngModelChange)="inputModelChanged(project.projectCategory)"
				[disabled]="defaultDisabledCondition()"
				[attr.e2evalue]="project.projectCategory"
				[ngStyle]="{color: isEditMode ? 'black' : 'gray'}"
			>
				@for (option of projectCategories; track option) {
					<mat-option [value]="option.value" id="select-option-{{ option.value }}"
						>{{ option.viewValue | translate }}
					</mat-option>
				}
			</mat-select>
			@if (
				(isAddMode && projectCategory.control.untouched) ||
				(isAddMode && projectCategory.control.untouched && !projectCategory.value) ||
				(isEditMode && !projectCategory.value)
			) {
				<mat-hint [ngStyle]="{color: 'red'}">
					{{ _lang("attributes.project-category-required") }}
				</mat-hint>
			}
		</mat-form-field>
	</div>
	<div class="col-6">
		<mat-form-field class="lessPadding" [matTooltip]="_lang('opportunity_ID_Tooltip')">
			<mat-label>{{ _lang("attributes.opportunity_ID") }}</mat-label>
			<input
				matInput
				maxlength="255"
				id="project_data_input-opportunityID"
				[disabled]="defaultDisabledCondition()"
				[(ngModel)]="project.opportunityID"
				(ngModelChange)="inputModelChanged(project.opportunityID)"
			/>
		</mat-form-field>
	</div>
	<div class="col-6">
		<mat-form-field class="lessPadding" matTooltip="{{ _lang('business_topic_tooltip') }}">
			<mat-label>{{ _lang("attributes.business_topics") }}</mat-label>
			<mat-select
				autosize
				[(ngModel)]="project.businessTopic"
				id="project_data_input-business_topics"
				(ngModelChange)="inputModelChanged(project.businessTopic)"
				[attr.e2evalue]="project.businessTopic"
				[disabled]="defaultDisabledCondition()"
			>
				@if (initialBusinessTopics) {
					<mat-option>
						<app-select-search [list]="initialBusinessTopics" (filtered)="onSearchSelectFiltered($event)">
						</app-select-search>
					</mat-option>
				}
				@for (object of businessTopics; track object) {
					<mat-option [value]="object.value" id="select-option-{{ object.value }}"
						>{{ object.viewValue | translate }}
					</mat-option>
				}
			</mat-select>
		</mat-form-field>
	</div>
</div>

<div class="row">
	<div class="col-6">
		@if (!isCurrentClientGBP()) {
			<mat-form-field class="lessPadding">
				<mat-label>{{ _lang("attributes.main_cluster") }}</mat-label>
				<input
					matInput
					maxlength="255"
					id="project_data_input-mainCluster"
					[disabled]="defaultDisabledCondition()"
					[(ngModel)]="project.mainCluster"
					(ngModelChange)="inputModelChanged(project.mainCluster)"
				/>
			</mat-form-field>
		}
	</div>
	<div class="col-6">
		@if (!isCurrentClientGBP() || project.businessUnit === "GBP") {
			<mat-form-field class="lessPadding">
				<mat-label>{{ _lang("attributes.billing_type") }}</mat-label>
				<mat-select
					[(ngModel)]="project.billingType"
					id="project_data_input-billing_type"
					(ngModelChange)="inputModelChanged(project.billingType)"
					[attr.e2evalue]="project.billingType"
					[disabled]="defaultDisabledCondition()"
				>
					@for (object of billingType; track object) {
						<mat-option [value]="object.value" id="select-option-{{ object.value }}"
							>{{ object.viewValue | translate }}
						</mat-option>
					}
				</mat-select>
			</mat-form-field>
		}
	</div>
</div>
<div class="row">
	<div class="col-6">
		<mat-form-field
			class="lessPadding"
			matTooltip="{{ _lang('attributes.offer-reference') }}"
			matTooltipClass="raised-tooltip"
		>
			<mat-label>{{ _lang("attributes.offer") }}</mat-label>
			<input
				matInput
				maxlength="255"
				id="project_data_input-offer"
				[disabled]="defaultDisabledCondition()"
				[(ngModel)]="project.offer"
				(ngModelChange)="inputModelChanged(project.offer)"
			/>
		</mat-form-field>
	</div>
	<div class="col-6">
		<mat-form-field
			class="lessPadding"
			matTooltip="{{ _lang('attributes.priorities') }}"
			matTooltipClass="raised-tooltip"
		>
			<mat-label>{{ _lang("attributes.priority") }}</mat-label>
			<input
				matInput
				maxlength="255"
				id="project_data_input-priority"
				[disabled]="defaultDisabledCondition()"
				[(ngModel)]="project.priority"
				(ngModelChange)="inputModelChanged(project.priority)"
				type="number"
			/>
		</mat-form-field>
	</div>
</div>
<div class="row">
	<div class="col-12">
		<mat-form-field class="pt-2 mat-form-field-w-auto lessPadding">
			<mat-label>{{ _lang("attributes.furtherInfo") }}</mat-label>
			@if ((!isEditMode || !projectEditable) && isUrl(project.furtherInfo)) {
				<a class="pe-auto" href="{{ project.furtherInfo }}" target="_blank">
					{{ project.furtherInfo }}
				</a>
			}
			<input
				maxlength="1000"
				[class.invisible]="(!isEditMode || !projectEditable) && isUrl(project.furtherInfo)"
				matInput
				id="project_data_input-furtherInfo"
				[(ngModel)]="project.furtherInfo"
				(ngModelChange)="inputModelChanged(project.furtherInfo)"
				[disabled]="defaultDisabledCondition()"
			/>
		</mat-form-field>
	</div>
</div>

<div class="row">
	<div class="col-12">
		<mat-form-field class="pt-2 pb-3 mat-form-field-w-auto lessPadding">
			<mat-label>{{ _lang("annotation") }}</mat-label>
			<textarea
				#annotation="ngModel"
				id="project_data_input-annotation"
				matInput
				maxlength="1000"
				name="annotation"
				[disabled]="!isEditMode"
				[(ngModel)]="project.annotation"
				(ngModelChange)="inputModelChanged(project.annotation)"
			></textarea>
		</mat-form-field>
	</div>
</div>

@if (isCurrentClientGBP()) {
	<div class="row">
		<div class="col-6">
			<mat-form-field class="lessPadding">
				<mat-label>{{ _lang("attributes.delivery_type") }}</mat-label>
				<mat-select
					#delivery="ngModel"
					[(ngModel)]="project.deliveryType"
					[attr.e2evalue]="project.deliveryType"
					(ngModelChange)="inputModelChanged(project.deliveryType)"
					[disabled]="defaultDisabledCondition()"
					[required]="false"
					id="project_data_input-delivery_type"
				>
					@for (type of deliveryType; track type) {
						<mat-option [value]="type" id="select-option-{{ type }}">
							{{ "mep.enum.delivery-type." + type | translate }}
						</mat-option>
					}
				</mat-select>
			</mat-form-field>
		</div>
		<div class="col-6">
			<mat-form-field class="lessPadding">
				<mat-label>{{ _lang("attributes.profit_center") }}</mat-label>
				<input
					matInput
					[disabled]="defaultDisabledCondition()"
					[(ngModel)]="project.profitCenter"
					(ngModelChange)="inputModelChanged(project.profitCenter)"
				/>
			</mat-form-field>
		</div>
	</div>
	<div class="row g-0 mb-6">
		<mat-checkbox
			[(ngModel)]="project.monthlyReporting"
			(ngModelChange)="inputModelChanged(project.monthlyReporting)"
			[disabled]="defaultDisabledCondition()"
			matTooltip="{{ _lang('attributes.monthly_reportingTooltip') }}"
		>
			{{ _lang("attributes.monthly_reporting") }}
		</mat-checkbox>
	</div>
	<div class="row g-0 mb-6">
		<mat-checkbox
			[(ngModel)]="project.effortControlling"
			(ngModelChange)="inputModelChanged(project.effortControlling)"
			[disabled]="defaultDisabledCondition()"
		>
			{{ _lang("attributes.effort_controlling") }}
		</mat-checkbox>
	</div>
	<!-- Relevant for msg.Romania-->
	<div class="row g-0 mb-6">
		<mat-checkbox
			[(ngModel)]="project.msgRomaniaRelevant"
			(ngModelChange)="inputModelChanged(project.msgRomaniaRelevant)"
			[disabled]="defaultDisabledCondition()"
		>
			{{ _lang("attributes.msg_Romania_Relevant") }}
		</mat-checkbox>
	</div>
	<fieldset class="border rounded my-3" [hidden]="!project.msgRomaniaRelevant">
		<legend class="mb-3 ms-2 w-auto legend-text">{{ _lang("attributes.msg_Romania_Relevant-legend-text") }}</legend>
		<div class="row g-0">
			<div class="col-6 px-3">
				<mat-form-field class="lessPadding">
					<mat-label> {{ _lang("attributes.responsible_al") }}</mat-label>
					<input
						[(ngModel)]="project.responsibleAL"
						id="project_data_input-responsibleAL"
						matInput
						maxlength="255"
						(ngModelChange)="inputModelChanged(project.responsibleAL)"
						[disabled]="defaultDisabledCondition()"
						[matAutocomplete]="autoResponsibleAL.matAutocomplete"
						#responsibleALInput
					/>
					<app-employee-autocomplete
						#autoResponsibleAL
						(elementSelected)="updateResponsibleAL($event)"
						[inputElement]="responsibleALInput"
					>
					</app-employee-autocomplete>
				</mat-form-field>
			</div>
			<div class="col-6 px-3">
				<mat-form-field class="lessPadding">
					<mat-label> {{ _lang("attributes.delivery_Responsible_Msg_Ro") }}</mat-label>
					<input
						[(ngModel)]="project.deliveryResponsibleMsgRo"
						id="project_data_input-deliveryResponsibleMsgRo"
						matInput
						maxlength="255"
						(ngModelChange)="inputModelChanged(project.deliveryResponsibleMsgRo)"
						[disabled]="defaultDisabledCondition()"
						[matAutocomplete]="autoDeliveryResponsibleMsgRo.matAutocomplete"
						#deliveryResponsibleMsgRoInput
					/>
					<app-employee-autocomplete
						#autoDeliveryResponsibleMsgRo
						(elementSelected)="updateDeliveryResponsibleMsgRo($event)"
						[inputElement]="deliveryResponsibleMsgRoInput"
					>
					</app-employee-autocomplete>
				</mat-form-field>
			</div>
			<div class="col-12 px-3">
				<mat-form-field class="mat-form-field-w-auto lessPadding">
					<mat-label>{{ _lang("attributes.portfolio_Msg_Ro") }}</mat-label>
					<textarea
						id="project_data_input-portfolioMsgRo"
						matInput
						maxlength="30"
						[disabled]="defaultDisabledCondition()"
						[(ngModel)]="project.portfolioMsgRo"
						(ngModelChange)="inputModelChanged(project.portfolioMsgRo)"
					></textarea>
				</mat-form-field>
			</div>
		</div>
	</fieldset>
	<fieldset class="border rounded my-3">
		<legend class="mb-3 ms-2 w-auto legend-text">
			{{ _lang("information-security") }}
			<mat-icon class="mep-info-icon" (click)="openInfoDialog()">info</mat-icon>
		</legend>
		<div class="row g-0">
			<div class="col-6 px-3">
				<mat-form-field class="lessPadding">
					<mat-label>{{ _lang("attributes.information_security_relevant") }}</mat-label>
					<mat-select
						[(ngModel)]="project.informationSecurityRelevant"
						id="project_data_input-information_security_relevant"
						(ngModelChange)="inputModelChanged(project.informationSecurityRelevant)"
						[attr.e2evalue]="project.informationSecurityRelevant"
						[disabled]="defaultDisabledCondition()"
					>
						<mat-option [value]="true" id="select-option-{{ 'true' }}"
							>{{ "mep.enums.protection-sbf.yes" | translate }}
						</mat-option>
						<mat-option [value]="false" id="select-option-{{ 'false' }}"
							>{{ "mep.enums.protection-sbf.no" | translate }}
						</mat-option>
						<mat-option [value]="undefined" id="select-option-{{ 'missing_value' }}"
							>{{ "mep.enums.protection-sbf.missing_value" | translate }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
			<div class="col-6 px-3">
				<mat-form-field class="lessPadding">
					<mat-label>{{ _lang("attributes.protection-needs-assessment") }}</mat-label>
					<mat-select
						#projectProtectionNeedsAssessment="ngModel"
						id="project_data_input-protection-needs-assessment"
						[(ngModel)]="project.protectionNeedsAssessment"
						(ngModelChange)="inputModelChanged(project.protectionNeedsAssessment)"
						[attr.e2evalue]="project.protectionNeedsAssessment"
						[disabled]="defaultDisabledCondition()"
					>
						<mat-option [value]="true" id="select-option-{{ 'true' }}"
							>{{ "mep.enums.protection-sbf.yes" | translate }}
						</mat-option>
						<mat-option [value]="false" id="select-option-{{ 'false' }}"
							>{{ "mep.enums.protection-sbf.no" | translate }}
						</mat-option>
						<mat-option [value]="undefined" id="select-option-{{ 'missing_value' }}"
							>{{ "mep.enums.protection-sbf.missing_value" | translate }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
		</div>
		<div class="row g-0">
			<div class="col-6 px-3">
				<mat-form-field class="lessPadding">
					<mat-label>{{ _lang("attributes.project_critically") }}</mat-label>
					<mat-select
						[(ngModel)]="project.critically"
						id="project_data_input-project_critically"
						(ngModelChange)="inputModelChanged(project.critically)"
						[attr.e2evalue]="project.critically"
						[disabled]="defaultDisabledCondition()"
					>
						@for (crit of projectCritically; track crit) {
							<mat-option [value]="crit" id="select-option-{{ crit }}">
								{{ "mep.enum.project-critically." + crit | translate }}
							</mat-option>
						}
					</mat-select>
				</mat-form-field>
			</div>
		</div>
		<div class="row g-0 mb-2">
			<div class="col-12 px-3">
				<mat-form-field
					matTooltip="{{ _lang('attributes.information_security_relevant_tooltip') }}"
					class="mat-form-field-w-auto lessPadding"
				>
					<mat-label>{{ _lang("attributes.link_is") }}</mat-label>
					@if ((!isEditMode || !projectEditable) && isUrl(project.linkIS)) {
						<a href="{{ project.linkIS }}" rel="noopener" target="_blank">
							{{ project.linkIS }}
						</a>
					}
					<input
						[hidden]="(!isEditMode || !projectEditable) && isUrl(project.linkIS)"
						matInput
						maxlength="255"
						id="project_data_input-information_security_relevant_tooltip"
						[(ngModel)]="project.linkIS"
						(ngModelChange)="inputModelChanged(project.linkIS)"
						[disabled]="defaultDisabledCondition()"
					/>
				</mat-form-field>
			</div>
		</div>
	</fieldset>
}
@if (project.lastModifiedBy) {
	<div class="row">
		<div class="col">
			{{ _lang("attributes.last-modified-by") + project?.lastModifiedBy || "-" }}
			{{ project?.lastModifiedAt | date: "dd.MM.yyyy HH:mm" || "-" }}
		</div>
	</div>
}
